import * as React from 'react';

export const AiAssistIconSvg = () => (
  <svg
    viewBox="0 0 43 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M17.8333 10.5833L16.7586 13.4876C15.3495 17.2958 14.6449 19.2 13.2558 20.5891C11.8667 21.9781 9.96258 22.6827 6.15427 24.0921L3.25 25.1666L6.15427 26.2412C9.96258 27.6506 11.8667 28.3552 13.2558 29.7441C14.6449 31.1333 15.3495 33.0375 16.7586 36.8456L17.8333 39.75L18.9079 36.8456C20.3173 33.0375 21.0219 31.1333 22.4108 29.7441C23.8 28.3552 25.7042 27.6506 29.5123 26.2412L32.4167 25.1666L29.5123 24.0921C25.7042 22.6827 23.8 21.9781 22.4108 20.5891C21.0219 19.2 20.3173 17.2958 18.9079 13.4876L17.8333 10.5833Z"
      stroke="currentColor"
      strokeWidth="3.125"
      strokeLinejoin="round"
    />
    <path
      d="M34.5 2.25L34.0394 3.49469C33.4354 5.12681 33.1335 5.9429 32.5381 6.53819C31.9429 7.1335 31.1269 7.43548 29.4948 8.03942L28.25 8.5L29.4948 8.96058C31.1269 9.56452 31.9429 9.8665 32.5381 10.4618C33.1335 11.0571 33.4354 11.8732 34.0394 13.5053L34.5 14.75L34.9606 13.5053C35.5646 11.8732 35.8665 11.0571 36.4619 10.4618C37.0571 9.8665 37.8731 9.56452 39.5052 8.96058L40.75 8.5L39.5052 8.03942C37.8731 7.43548 37.0571 7.1335 36.4619 6.53819C35.8665 5.9429 35.5646 5.12681 34.9606 3.49469L34.5 2.25Z"
      stroke="currentColor"
      strokeWidth="3.125"
      strokeLinejoin="round"
    />
  </svg>
);
